import { STRINGS } from '@/constants/strings';
import { emailRule } from '@/validation';
import * as yup from 'yup';

/** Reuse the shared validation copy so guardian forms stay consistent. */
const MESSAGES = STRINGS.mutatePlayer.validation;

/** Optional personal note attached to the invitation. */
export const MAX_INVITE_MESSAGE_LENGTH = 500;

/** Invite Guardian form — relationship, email (required) and an optional message. */
export const inviteGuardianSchema = yup
  .object({
    role: yup.string().trim().required(MESSAGES.fieldRequired),
    email: emailRule(MESSAGES.fieldRequired, MESSAGES.emailInvalid),
    message: yup.string().trim().defined().max(MAX_INVITE_MESSAGE_LENGTH),
  })
  .required();

export type InviteGuardianForm = {
  role: string;
  email: string;
  message: string;
};

export const INITIAL_INVITE_GUARDIAN_FORM: InviteGuardianForm = {
  role: 'other',
  email: '',
  message: '',
};
